function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("title", null, "login-icon");

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M369,209,201,377c-15,15-41,4.5-41-17V264H24A23.94,23.94,0,0,1,0,240.12V144a23.94,23.94,0,0,1,23.88-24H160V24c0-21.4,25.9-32,41-17L369,175A24.2,24.2,0,0,1,369,209ZM312,12V52a12,12,0,0,0,12,12h84a32,32,0,0,1,32,32V288a32,32,0,0,1-32,32H324a12,12,0,0,0-12,12v40a12,12,0,0,0,12,12h84a96,96,0,0,0,96-96V96A96,96,0,0,0,408,0H324A12,12,0,0,0,312,12Z",
  transform: "translate(0 0.02)"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 503.98,
    height: 384.06,
    viewBox: "0 0 503.98 384.06"
  }, props), _ref, _ref2);
};

export default __webpack_public_path__ + "static/media/login-icon.58a8a061.svg";
export { SvgComponent as ReactComponent };